module.exports = __webpack_public_path__ + "static/media/trent.e2c0f8c7.png";